import { render } from "./IRR3dbar.vue?vue&type=template&id=990d3ca6"
import script from "./IRR3dbar.vue?vue&type=script&lang=js"
export * from "./IRR3dbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__